import { useContext } from 'react'
import { ConfirmationContext, ConfirmationContextType } from '../components'

export const useConfirmationContext = () =>
  useContext<ConfirmationContextType>(ConfirmationContext)
